<header class="lum-c-sales-order-form__head flex flex-row">
  <h3 class="flex flex-auto">Create Sales Order Invoice</h3>
  <div class="flex flex-auto align-right">
    <button
      mat-dialog-close
      aria-label="Close 'Create Sales Order' Dialog"
      class="close lum-c-sales-order-form__close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
</header>

<mat-divider></mat-divider>
<div mat-dialog-content *ngIf="isLoading$ | async" class="spinner-container">
  <mat-spinner [diameter]="50"> </mat-spinner>
</div>

<div mat-dialog-content *ngIf="!(isLoading$ | async)">
  <div class="flex flex-row my-3">
    <h4 class="sales-order-info flex flex-auto">
      <span class="lum-c-sales-order-form__info-title"
        >Sales Order Number: &nbsp;
      </span>
      <span class="lum-c-sales-order-form__info-value">{{
        salesOrder.orderNumber
      }}</span>
    </h4>
    <div class="align-right flex flex-auto action-buttons">
      <button mat-raised-button color="secondary" (click)="onSetFulfilled()">
        Set Fulfilled
      </button>
      <button mat-raised-button color="secondary" (click)="onSetOrdered()">
        Set Ordered
      </button>
    </div>
  </div>
  <lum-create-invoice-ag-grid-table
    [salesOrderFormLineItems]="salesOrderFormLineItems"
    (totalQuantityToInvoice)="onQuantityToInvoiceUpdated($event)"
  ></lum-create-invoice-ag-grid-table>
</div>

<footer mat-dialog-actions class="lum-c-sales-order-form__foot mt-3 flex flex-row">
  <div class="total-quantity flex-auto">
    <span class="lum-c-sales-order-form__info-title"
      >Total Quantity to Invoice: &nbsp;</span
    >
    <span class="lum-c-sales-order-form__info-value">{{
      totalQuantity$ | async
    }}</span>
  </div>
  <div class="action-buttons align-right flex-auto">
    <button mat-button (click)="onClose()">
      <mat-icon>close</mat-icon>
      Close
    </button>

    <button
      mat-raised-button
      color="primary"
      [disabled]="isLoading$ | async"
      (click)="onSave()"
    >
      <mat-icon>save</mat-icon>
      Create Invoice
    </button>
  </div>
</footer>
